export default {
  label: "Mapa",
  route: "Ruta",
  AssetPositioning: "Posicionamiento de Activos",
  coordinateN: "coordenada N",
  coordinateE: "coordenada E",
  lat: "Lat. ° (N)",
  lon: "Lon. ° (E)",
  searchRadius: "Radio de Búsqueda (m)",
  WGS: "Grado Decimal (WGS84)",
};
